import React, {
    useEffect, useState, useContext, useCallback
} from 'react';
import { Link } from 'react-router-dom';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import PropTypes from 'prop-types';
import { AccountService } from 'gw-capability-gateway-policy';
import { PolicyService } from 'gw-capability-gateway';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { Icon, Loader, Chevron } from '@jutro/components';
import { TranslatorContext, IntlContext } from '@jutro/locale';
import {getFontIcon} from '../../../utils/lobIconUtil';
import SearchResults from '../SearchResults/SearchResults';
import messages from '../Accounts/Accounts.messages';
import metadata from './SRELandingPage.metadata.json5';
import SRELandingPageMessages from './SRELandingPage.messages';
import styles from './SRELandingPage.module.scss';
import {JobService} from "gw-capability-gateway";

function SRELandingPage(props) {
    const [accountData, setAccountData] = useState([]);
    const [policiesData, setPoliciesData] = useState([]);
    const [submissionsData, setSubmissionsData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [searchText, updateSearchText] = useState(undefined);
    const [search, updateSearch] = useState(false);
    const translator = useContext(TranslatorContext);
    const { authHeader } = props;
    const intl = useContext(IntlContext);

    const writeValue = useCallback((value) => {
        updateSearchText(value);
        updateSearch(false);
    }, []);
    const getCell = useCallback(
        (items, index, { id: property }) => {
            const tooltipMessages = {
                dateCreated: translator(messages.DateCreated),
                address: translator(messages.Address),
                displayStatus: translator(messages.status),
                premium: translator(messages.premium),
                effectiveDate: translator(messages.effectiveDate),
                expirationDate: translator(messages.expirationDate)
            };

            const toolTipMessage = tooltipMessages[property] || '';
            return <span title={toolTipMessage}>{items[property]}</span>;
        },
        [translator]
    );

    const getAccount = useCallback(
        (item, index, { id: property }) => {
            const toolTipMessage = translator(messages.Account);
            return (
                <div className={styles.linkAccount}>
                   
                    <Link to={`/accounts/${item.accountNumber}/summary`} title={toolTipMessage}>
                        {item[property]}
                    </Link>
                </div>
            );
        },
        [translator]
    );

    const getType =useCallback(
        (item, index, { id: property }) => {
            const icon = item.type === 'Personal' ? 'mi-person' : 'mi-apartment';
            return (
                <Icon icon={icon} />
            );
        },
        [translator]
    );

    const getHeaderSection = (title) => {
        
        return (isOpen) => (
            <React.Fragment>
                <Chevron isOpen={isOpen} align="right" />
                <h2 className={`${styles.title} ${styles.gwOverrideDefaultMargin}`}>{title}</h2>
            </React.Fragment>
        );
    };

    const getPolicyLink = useCallback(
        (item, index, { id: property }) => {
            let toolTipMessage = messages.OpenActivities;
            let redirectPath = 'activities';

            if (property === 'policy') {
                toolTipMessage = messages.Policies;
                redirectPath = 'summary';
            }

            return (
                <Link
                    to={{
                        pathname: `/accounts/${item.accountNumber}/${redirectPath}`,
                        state: redirectPath
                    }}
                    title={translator(toolTipMessage)}
                >
                    {item[property]}
                </Link>
            );
        },
        [translator]
    );

    const processResponseData = useCallback((data) => {
        const accountArray = data.filter((accountInfo) => {
            return accountInfo !== undefined && accountInfo.accountHolderAddress !== undefined;
        }).map((accountInfo) => {
            const isPersonal = accountInfo.isPersonalAccount;
            const account = {
                type: isPersonal ? 'Personal' : 'Commercial',
                insuredName: accountInfo.accountHolder,
                policy: accountInfo.policySummaries.length,
                dateCreated: intl.formatDate(new Date(accountInfo.accountCreatedDate), { year: 'numeric', month: 'short', day: 'numeric' }),
                address: accountInfo.accountHolderAddress.displayName,
                openActivities: accountInfo.numberOfOpenActivities,
                accountNumber: accountInfo.accountNumber
            };
            return account;
        });
        return accountArray;
    }, []);

    const setAccountResponse = useCallback(
        (response) => {
            setAccountData(processResponseData(response));
        },
        [processResponseData]
    );

    const getProductImage = useCallback((item) => {
        const icon = getFontIcon(item.productCode);
        return (
            <Icon
                icon={icon}
                title={item.productName}
            />
        );
    }, []);

    const getPoliciesCell = useCallback(
        (item, index, { id: property }) => {
            const toolTipMessage = translator(messages.insuredName);

            return <span title={toolTipMessage}>{item[property]}</span>;
        },
        [translator]
    );

    const getLink = useCallback(
        (item, index, { id: property }) => {
            return (
                <Link
                    to={`/policies/${item[property]}/summary`}
                    className={styles.removeLinkStyle}
                    title={translator(messages[property])}
                >
                    {item[property]}
                </Link>
            );
        },
        [translator]
    );

    const getAccountNumberLink = useCallback(
        (item, index, { id: property }) => {
            const toolTipMessage = translator(messages.Account);
            const { accountHolderName } = item;
            return (
                <Link
                    to={`/accounts/${item[property]}/summary`}
                    className={styles.removeLinkStyle}
                    title={toolTipMessage}
                >
                    {accountHolderName}
                </Link>
            );
        },
        [translator]
    );

    const getQuoteLink = useCallback(
        (item, index, { id: property }) => {
            return (
                <Link
                    to={`/quotes/${item[property]}/summary`}
                    className={styles.removeLinkStyle}
                    title={translator(messages[property])}
                >
                    {item[property]}
                </Link>
            );
        },
        [translator]
    );

    const setPoliciesResponse = useCallback((data) => {
        const policyItems = [];

        data.forEach((policyDetails) => {
            //const { amount, currency } = policyDetails.premium;
            const { amount, currency } = policyDetails.premium !== undefined ?policyDetails.premium : {amount:0,currency:""};
            const premiumAmount = intl.formatNumber(
                amount,
                {
                    style: 'currency',
                    currency: currency,
                    currencyDisplay: 'symbol'
                }
            );
            const policy = {
                productCode: policyDetails.product.productCode,
                productName: policyDetails.product.productName,
                insuredName: policyDetails.primaryInsuredName,
                displayStatus: policyDetails.displayStatus,
                accountNumber: policyDetails.accountNumber,
                policyNumber: policyDetails.policyNumber,
                account: policyDetails.accountNumber,
                accountHolderName: policyDetails.accountHolderName,
                primaryInsuredName: policyDetails.primaryInsuredName,
                premium: premiumAmount,
                effectiveDate: intl.formatDate(new Date(policyDetails.effective), { year: 'numeric', month: 'short', day: 'numeric' }),
                expirationDate: intl.formatDate(new Date(policyDetails.expiration), { year: 'numeric', month: 'short', day: 'numeric' })
            };
            policyItems.push(policy);
            return true;
        });
        setPoliciesData(policyItems);
    }, []);

    const setQuotesResponse = useCallback((data) => {
        const quoteItems = [];

        data.forEach((quoteDetails) => {
            const { amount, currency } = quoteDetails.totalPremium;
            const premiumAmount = intl.formatNumber(
                amount,
                {
                    style: 'currency',
                    currency: currency,
                    currencyDisplay: 'symbol'
                }
            );
            const submission = {
                productCode: quoteDetails.product.productCode,
                productName: quoteDetails.product.productName,
                displayStatus: quoteDetails.status,
                jobNumber: quoteDetails.jobNumber,
                accountHolderName: quoteDetails.accountHolderName,
                account: quoteDetails.accountNumber,
                accountNumber: quoteDetails.accountNumber,
                premium: premiumAmount,
                createdDate: intl.formatDate(new Date(quoteDetails.createTime), { year: 'numeric', month: 'short', day: 'numeric' }),
                effectiveDate: intl.formatDate(new Date(quoteDetails.policyEffectiveDate), { year: 'numeric', month: 'short', day: 'numeric' })
            };
            quoteItems.push(submission);
            return true;
        });
        setSubmissionsData(quoteItems);
    }, []);

    useEffect(() => {
        AccountService.getRecentlyViewedAccounts(authHeader).then((accountsResponse) => {
            setAccountResponse(accountsResponse, messages.RecentlyViewed);
            setIsLoading(false);
        }).catch((e) => {
            console.error('PolicyDetailsError', e);
        });

        PolicyService.getRecentlyViewedPolicies(authHeader).then((policiesResponse) => {
            setPoliciesResponse(policiesResponse);
            setIsLoading(false);
        });

        JobService.findRecentSubmissionSummariesByUser(authHeader).then((quotesResponse) => {
            setQuotesResponse(quotesResponse)
            setIsLoading(false);
        });
    }, [authHeader, setAccountResponse, setPoliciesResponse, setQuotesResponse]);

    const handleClick = useCallback(() => {
        if (searchText) {
            updateSearch(true);
        }
    }, [searchText]);

    const overrides = {
        recentlyViewedTableGrid: {
            visible: accountData.length > 0,
            data: accountData
        },
        recentlyViewedPoliciesTableGrid: {
            visible: policiesData.length > 0,
            data: policiesData
        },
        recentlyViewedQuotesTableGrid: {
            visible: submissionsData.length > 0,
            data: submissionsData
        },
        searchResults: {
            param: search ? searchText : '',
            title: translator(SRELandingPageMessages.searchResults, {
                query: searchText
            }),
            visible: searchText !== undefined,
            noResultsMessage: translator(SRELandingPageMessages.noSearchresultsFound)
        },
        searchBox: {
            onValueChange: writeValue,
            value: searchText,
            onEnter: handleClick
        },
        searchBtn: {
            onClick: handleClick
        },
        searchResultsContainer: {
            visible: search && searchText !== undefined
        },
        noPoliciesFound: {
            visible: !policiesData.length
        },
        noQuotesFound: {
            visible: !submissionsData.length
        },
        noAccountsFound: {
            visible: !accountData.length
        },
        recentAccountsAccordionCardSection: {
            header: getHeaderSection(translator(SRELandingPageMessages.recentlyVisitedAccounts))
        },
        recentQuotesAccordionCardSection: {
            header: getHeaderSection(translator(SRELandingPageMessages.recentlyVisitedQuotes))
        },
        recentPolicyAccordionCardSection: {
            header: getHeaderSection(translator(SRELandingPageMessages.recentlyVisitedPolicies))
        }
    };
    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            getCell,
            getProductImage,
            getPoliciesCell,
            getAccount,
            getPolicyLink,
            getAccountNumberLink,
            getLink,
            getQuoteLink,
            getType
        },
        resolveComponentMap: {
            searchresults: SearchResults
        }
    };
    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }
    const landingPage = renderContentFromMetadata(metadata.pageContent, overrides, resolvers);
    return <div className={styles.landingStyles}>{landingPage}</div>;
}

SRELandingPage.propTypes = {
    authHeader: PropTypes.shape({}).isRequired
};

export default withAuthenticationContext(SRELandingPage);
